import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { blockchainService } from '../../services/blockchainService';

interface WalletStatusProps {
  userAddress: string | null;
}

const WalletStatus: React.FC<WalletStatusProps> = ({ userAddress }) => {
  const { t } = useTranslation();
  const [networkInfo, setNetworkInfo] = useState<any>(null);
  const [isLoading, setIsLoading] = useState(false);

  useEffect(() => {
    if (userAddress && blockchainService.isConnected()) {
      loadNetworkInfo();
    }
  }, [userAddress]);

  const loadNetworkInfo = async () => {
    setIsLoading(true);
    try {
      const info = await blockchainService.getNetworkInfo();
      setNetworkInfo(info);
    } catch (error) {
      console.error('Failed to get network info:', error);
    } finally {
      setIsLoading(false);
    }
  };

  if (!userAddress) {
    return (
      <div className="bg-red-50 border border-red-200 rounded-lg p-3">
        <div className="flex items-center">
          <div className="w-2 h-2 bg-red-500 rounded-full mr-2"></div>
          <span className="text-red-700 text-sm">{t('wallet.notConnected')}</span>
        </div>
      </div>
    );
  }

  return (
    <div className="bg-green-50 border border-green-200 rounded-lg p-3">
      <div className="flex items-center justify-between">
        <div className="flex items-center">
          <div className="w-2 h-2 bg-green-500 rounded-full mr-2"></div>
          <span className="text-green-700 text-sm">
            {t('wallet.connected')}: {userAddress.slice(0, 6)}...{userAddress.slice(-4)}
          </span>
        </div>
        
        {networkInfo && (
          <div className="text-xs text-green-600">
            {networkInfo.name} (Chain ID: {networkInfo.chainId})
          </div>
        )}
        
        {isLoading && (
          <div className="text-xs text-green-600">
            {t('wallet.connectionStatus.connecting')}
          </div>
        )}
      </div>
    </div>
  );
};

export default WalletStatus;
